import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const ProductSelectorApi = {
  getProductListData: () => {
    const url = `/product-selector/category/all`;
    return request({
      method: HTTP_METHOD.GET,
      url,
    });
  },
  getProductQuestion: (payload) => {
    const {category,keys}=payload;
    const url = `product-selector/category/${category}/question/next`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data:{keys}
    });
  },
  postAnswerSubmit: (payload) => {
    const {category,keys}=payload;
    const url = `/product-selector/category/${category}/submit`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      data:keys
    });
  },

};

export default ProductSelectorApi;
